import { useEffect, useState } from "react";
import { api, euro } from "@/lib/api";

export default function AdminOrders() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/orders").then((r) => setList(r.data)); }, []);

  if (!list.length) return <p className="text-zinc-500" data-testid="admin-orders-empty">Nessun ordine pagato.</p>;
  return (
    <div className="overflow-x-auto border border-zinc-800" data-testid="admin-orders">
      <table className="w-full text-sm">
        <thead className="bg-[#121215] text-xs uppercase tracking-widest text-zinc-400">
          <tr>{["Data", "Codice", "Cliente", "Articoli", "Importo"].map((h) => <th key={h} className="text-left px-4 py-3">{h}</th>)}</tr>
        </thead>
        <tbody>
          {list.map((o) => (
            <tr key={o.session_id} className="border-t border-zinc-800" data-testid={`admin-order-${o.order_code}`}>
              <td className="px-4 py-3 text-zinc-400 whitespace-nowrap">{new Date(o.paid_at || o.created_at).toLocaleString("it-IT")}</td>
              <td className="px-4 py-3 font-bold">{o.order_code}</td>
              <td className="px-4 py-3 text-zinc-400">{o.customer_email || "—"}</td>
              <td className="px-4 py-3">{o.items.map((i) => `${i.quantity}× ${i.name}`).join(", ")}</td>
              <td className="px-4 py-3 font-display italic font-black text-lg text-red-500">{euro(o.amount_paid ?? o.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
